import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const WebsiteTitle = () => {
  const location = useLocation();
  const title = location?.pathname.split("/")[1].split("-").join(" ");
  return (
    <Helmet>
      <title>{title?.length ? `Green Matter - ${title[0].toUpperCase()}${title.slice(1,)}` : "Green Matter"}</title>
    </Helmet>
  );
};

export default WebsiteTitle;
